// FMO Reports - Executive summary, exportable reports
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, FileText, Download, Calendar, Building2, Users, TrendingUp, DollarSign } from 'lucide-react';

export default function FmoReports() {
  const navigate = useNavigate();

  const reports = [
    { id: 'exec-summary', title: 'Executive Summary', description: 'High-level KPIs, retention trends, and risk overview', icon: FileText, color: 'text-blue-600 bg-blue-50' },
    { id: 'agency-perf', title: 'Agency Performance', description: 'Per-agency metrics, rankings, and retention comparison', icon: Building2, color: 'text-purple-600 bg-purple-50' },
    { id: 'agent-perf', title: 'Agent Performance', description: 'Individual agent scorecards, activity, and compliance', icon: Users, color: 'text-green-600 bg-green-50' },
    { id: 'retention', title: 'Retention Analysis', description: 'Churn trends, risk factors, intervention effectiveness', icon: TrendingUp, color: 'text-amber-600 bg-amber-50' },
    { id: 'revenue', title: 'Revenue Report', description: 'Commission breakdown by carrier, agency, and agent', icon: DollarSign, color: 'text-emerald-600 bg-emerald-50' },
    { id: 'enrollment', title: 'Enrollment Period', description: 'AEP/OEP outreach rates and conversion by agency', icon: Calendar, color: 'text-red-600 bg-red-50' },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white border-b border-gray-200 px-6 py-4">
        <div className="max-w-7xl mx-auto flex items-center gap-4">
          <button onClick={() => navigate('/fmo/dashboard')} className="p-2 hover:bg-gray-100 rounded-lg">
            <ArrowLeft size={20} className="text-gray-600" />
          </button>
          <div>
            <h1 className="text-2xl font-bold text-[#172A3A] flex items-center gap-2"><FileText className="text-blue-600" /> Reports</h1>
            <p className="text-sm text-gray-500">Generate and export executive reports</p>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {reports.map(report => (
            <div key={report.id} className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow">
              <div className={`w-12 h-12 rounded-xl ${report.color} flex items-center justify-center mb-4`}>
                <report.icon size={24} />
              </div>
              <h3 className="font-bold text-gray-900 mb-1">{report.title}</h3>
              <p className="text-sm text-gray-500 mb-4">{report.description}</p>
              <button className="flex items-center gap-2 text-sm font-medium text-blue-600 hover:text-blue-700">
                <Download size={16} /> Generate Report
              </button>
            </div>
          ))}
        </div>

        <div className="mt-8 bg-amber-50 border border-amber-200 rounded-xl p-4 text-sm text-amber-700">
          Report generation is coming soon. Reports will be exportable as PDF and CSV.
        </div>
      </div>
    </div>
  );
}
